/**
 * The kind of mapping possible (this allows type discrimination as per
 * [Typescript documentation](https://www.typescriptlang.org/docs/handbook/advanced-types.html#type-guards-and-differentiating-types))
 */
export var PropMappingType;
(function (PropMappingType) {
    PropMappingType["Property"] = "P";
    PropMappingType["PropertySetter"] = "S";
    PropMappingType["Event"] = "E";
})(PropMappingType || (PropMappingType = {}));
